"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var admin_edit_instructor_contact_info_controller_1 = __importDefault(require("./admin-edit-instructor-contact-info.controller"));
var admin_edit_instructor_contact_info_html_1 = __importDefault(require("./admin-edit-instructor-contact-info.html"));
function getInstructor($stateParams, UsersModel) {
    return UsersModel.getInstructorByID($stateParams.instructorId).then(function (response) {
        return response;
    });
}
getInstructor.$inject = ["$stateParams", "UsersModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.instructors.edit.contactinfo", {
        url: "/contact-info",
        controller: admin_edit_instructor_contact_info_controller_1.default,
        controllerAs: "vm",
        template: admin_edit_instructor_contact_info_html_1.default,
        resolve: {
            instructor: getInstructor,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.dashboard.instructors.edit.contactinfo", [])
    .config(config)
    .controller("AdminInstructorsEditContactInfoController", admin_edit_instructor_contact_info_controller_1.default);
